/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Receipt_Price_Per_SeatInputs */



/**
* | output |
* | --- |
* | "{price} per seat / month" |
*
* @param {Receipt_Price_Per_SeatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_price_per_seat = /** @type {((inputs: Receipt_Price_Per_SeatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Price_Per_SeatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.price} pro Platz / Monat`)
	return /** @type {LocalizedString} */ (`${i?.price} per seat / month`)
});